// const httpss = 'http://localhost:3004';
// const httpss = 'http://172.17.35.131:3004';
// const httpss = 'https://ticket.myu.vn';
// const httpss = 'https://mail.myu.vn';
const httpss = 'https://dashboard.myu.vn';

export {httpss};